// import HomePage from './home';
// import BlogPage from './blog';
import LoginPage from './login';
// import BlogIndex from './blogindex';
// import BlogItem from './blogitem';
// import DocumentationPage from './documentation';
import Error404 from './Error404';
import DynamicPage from './DynamicPage';

export const PageComponents = {
  // HomePage,
  LoginPage,
  // BlogPage,
  // BlogIndex,
  // BlogItem,
  // DocumentationPage,
  Error404,
  DynamicPage,
};